import { immer } from '../middelware/immer'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import type {
  NfdBrowseCategoryItem,
  NfdBrowseLengthItem,
  NfdBrowseSort,
  NfdBrowseStateItem
} from 'api/api-client'

export type PriceRange = {
  minPrice: number | null
  maxPrice: number | null
}

export type BrowseStore = {
  category: NfdBrowseCategoryItem[] | null
  setCategory: (category: NfdBrowseCategoryItem[] | null) => void

  length: NfdBrowseLengthItem[] | null
  setLength: (length: NfdBrowseLengthItem[] | null) => void

  sort: NfdBrowseSort | null
  setSort: (sort: NfdBrowseSort | null) => void

  state: NfdBrowseStateItem[] | null
  setState: (state: NfdBrowseStateItem[] | null) => void

  priceRange: PriceRange
  setPriceRange: (priceRange: PriceRange) => void

  name: string | null
  setName: (name: string | null) => void

  clearAllFilters: () => void
  resetDefault: () => void
}

export const useBrowseStore = create<BrowseStore>(
  devtools(
    persist(
      immer((set) => ({
        category: null,
        setCategory: (category) =>
          set((state) => {
            state.category = category
          }),

        length: null,
        setLength: (length) =>
          set((state) => {
            state.length = length
          }),

        sort: 'saleTypeAsc',
        setSort: (sort) =>
          set((state) => {
            state.sort = sort
          }),

        state: null,
        setState: (state_) =>
          set((state) => {
            state.state = state_
          }),

        priceRange: {
          minPrice: null,
          maxPrice: null
        },
        setPriceRange: (priceRange) =>
          set((state) => {
            state.priceRange = priceRange
          }),

        name: null,
        setName: (name) =>
          set((state) => {
            state.name = name
          }),

        clearAllFilters: () =>
          set((state) => {
            state.category = null
            state.length = null
            state.state = null
            state.priceRange = {
              minPrice: null,
              maxPrice: null
            }
            state.name = null
          }),

        resetDefault: () =>
          set((state) => {
            state.category = null
            state.length = null
            state.state = ['forSale']
            state.priceRange = {
              minPrice: null,
              maxPrice: null
            }
            state.name = null
            state.sort = 'saleTypeAsc'
          })
      })),
      {
        name: 'nfd-browse',
        version: 0
      }
    ),
    { name: 'local-storage' }
  )
)
